// Mirrors server/src/helpers/scheduling/shiftIdentity.js - shifts sharing
// these fields are treated as interchangeable vacancies for the same
// advertised requirement (e.g. "4x Paramedic, Saturday 08:00-20:00").
const getEntityId = (entity) => {
  if (!entity) return ''
  return typeof entity === 'string' ? entity : entity._id || ''
}

export const getShiftIdentityKey = (shift) =>
  [
    getEntityId(shift?.event) ||
      getEntityId(shift?.roster) ||
      getEntityId(shift?.ptsDuty) ||
      '',
    shift?.clinicalRole || '',
    shift?.start ? new Date(shift.start).toISOString() : '',
    shift?.end ? new Date(shift.end).toISOString() : '',
    shift?.payRate ?? '',
    !!shift?.hourlyRate,
    (shift?.bonuses ?? [])
      .map((bonus) => `${bonus?.label ?? ''}:${Number(bonus?.amount) || 0}`)
      .sort()
      .join(','),
    // '' for no travel (legacy shifts and 0/0 defaults alike)
    Number(shift?.travel?.beforeMinutes) || Number(shift?.travel?.afterMinutes)
      ? `${Number(shift.travel.beforeMinutes) || 0}:${Number(shift.travel.afterMinutes) || 0}:${Number(shift.travel.rate) || 0}`
      : '',
    shift?.eventAssignment || '',
  ].join('|')

// Only open, staff-bookable Event vacancies go through the merged
// multi-applicant review flow - swap requests, PTS, Roster shifts, and
// shifts already given to a subcontractor keep using the single-application
// review. Mirrors server isMergeableShift's exclusions exactly.
export const isMergeableApplicationShift = (shift) =>
  shift?.shiftType === 'Event' &&
  !!shift?.staffCanBook &&
  !shift?.assignedTo &&
  !shift?.assignedSubcontractor &&
  !shift?.assignedToSubcontractor

// A shift can be assigned outside the application-review flow entirely (e.g.
// a manager assigns it directly from the event page, or to a subcontractor),
// leaving any Pending applications against it stranded - there's no vacancy
// left to accept them into, so they're surfaced for bulk cleanup instead of
// normal review. Shifts offered for swap are still assigned by design, so
// they're excluded here and go through the normal single-application review
// instead.
export const isShiftAlreadyFilled = (shift) =>
  !shift?.availableForReassignment &&
  (!!shift?.assignedTo ||
    !!shift?.assignedSubcontractor ||
    !!shift?.assignedToSubcontractor)
